<mat-toolbar color="primary">
  <span id="møteprotokoll-send-til-signering-dialog-tittel">
    {{ "Send invitasjon til signering av protokoll fra {tittel} {nummer}"|translate: {tittel: moete().tittel, nummer: moete().nummer} }}
  </span>
  <button mat-icon-button aria-label="Lukk dialog" (click)="avbryt()">
    <mat-icon fontSet="ion-ios-close-empty" class="mat-icon--ionic-ikon"/>
  </button>
</mat-toolbar>
@if (laster()) {
  <mat-progress-bar mode="indeterminate"/>
}

@if (modus() == 'skjema') {
  <form [formGroup]="skjema" (ngSubmit)="sendTilSignering()" data-testid="møteprotokoll-send-til-signering-skjema" novalidate>
    <mat-dialog-content class="skjema">

      <mat-form-field>
        <mat-label>{{ 'Skriv inn beskjed inkludert i invitasjonen'|translate }}</mat-label>
        <riktekst-redigering [skjemakontroll]="skjema.controls.beskjed" [gruppeId]="moete().eiendeGruppeId" data-testid="beskjed-felt"/>
      </mat-form-field>

      <h4>
        {{ 'Deltakere som skal signere'|translate }}
        (<a (click)="gaaTilRedigerProtokoll()" class="rediger-protokoll">{{ 'Rediger protokoll'|translate }}</a>
        {{ 'for å endre signatarer'|translate }})
      </h4>
      <div class="signatarer">
        <medlemmer-listevisning-kompakt [medlemmer]="signatarer()" data-testid="signatarer"/>
      </div>

      <h4>{{ 'Signeringsmåte'|translate }}</h4>
      <p>{{ 'Velg hvordan brukere skal signere dokumentet. Du kan velge en eller flere metoder.'|translate }}</p>
      <signering-velg-aksepterte-metoder [skjemaKontroll]="skjema.controls.signaturmetoder"/>
      @if (skjema.controls.signaturmetoder.hasError('required')) {
        <div class="feilmelding">{{ 'Angi minst én signaturmåte'|translate }}</div>
      }
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <span>
        <button mat-button type="button" (click)="avbryt()">{{ "Avbryt"|translate }}</button>
        <submit-button [skjema]="skjema" [arbeidPaagaar]="lagrer()" spinnerTekst="{{'Sender...'|translate}}">
          {{ "Send signeringsinvitasjon"|translate }}
        </submit-button>
      </span>
      <!-- merk: bruker ikke @if for å vise/skjule huskSignaturmetodeValg - dette da vi trenger at elementet opptar plass selvom det ikke vises (derfor style.visibility) -->
      <mat-checkbox [formControl]="skjema.controls.huskSignaturmetodeValg"
                    [style.visibility]="signaturmetoderEndret()?'visible':'hidden'"
                    matTooltip="{{'Bruk dette som standard på møter i denne gruppen'|translate}}"
                    data-testid="huskSignaturmetodeValg">
        {{ 'Husk signeringsmåte' | translate }}
      </mat-checkbox>
    </mat-dialog-actions>
  </form>

} @else {

  <!-- modus != skjema -->
  @switch (modus()) {
    @case ('ingensignatarer') {
      <mat-dialog-content class="ingensignatarer" data-testid="invitasjonKanIkkeSendes">
        <p>{{ 'Invitasjon til å signere kan ikke sendes da ingen møtedeltakere er satt til å signere i protokollen.'|translate }}</p>
        <p>
          <a class="rediger-protokoll" (click)="gaaTilRedigerProtokoll()" data-testid="navigerTilRedigerProtokoll">{{ 'Rediger protokollen'|translate }}</a>
          {{ 'for å angi hvem som skal signere.'|translate }}
        </p>
      </mat-dialog-content>

    }
    @case ('ikkepublisert') {
      <mat-dialog-content class="ikkepublisert" data-testid="protokollIkkePublisert">
        <p>{{ 'Protokollen er ikke publisert og kan derfor ikke signeres.'|translate }}</p>
        <p>
          <button mat-raised-button color="primary" (click)="publiserProtokoll()">
            {{ 'Publiser protokoll'|translate }}
          </button>
        </p>
      </mat-dialog-content>

    }
    @case ('kvittering') {
      <mat-dialog-content class="kvittering" data-testid="kvittering">
        <p>{{ 'Invitasjon har blitt sendt til {antall} personer.'|translate: {antall: signatarer().length} }}</p>
        <tips>
          <p>{{ 'Merk at møte nå er låst og hverken møte, tilknyttede saker eller protokollen kan lenger redigeres.'|translate }}</p>
          <p>{{ 'Du kan låse opp møte dersom du trenger å gjøre endringer ved velge "lås opp møte for redigering" fra møtemenyen, men eventuelle protokollsignaturer vil da forsvinne.'|translate }}</p>
          <p>{{'Du finner en oversikt over meldinger sendt til medlemmer i'|translate}} <a (click)="gaaTilHendelseslogg()">{{'møtets hendelseslogg'|translate}}</a> </p>
        </tips>
        <melding-sendt-ikon/>
      </mat-dialog-content>
    }
  }
  <mat-dialog-actions align="center">
    <div>
      <button mat-raised-button color="primary" type="button" (click)="ferdig()" cdkFocusInitial data-testid="ferdig">
        {{ 'Lukk'|translate }}
      </button>
    </div>
  </mat-dialog-actions>
}
